import React from 'react';
import { ReactComponent as TikTokSvgIcon } from './../../assets/images/icons/tiktok.svg';
import SvgIcon from '@mui/material/SvgIcon';

const TikTokIcon = (props) => <SvgIcon component={TikTokSvgIcon} inheritViewBox {...props} />;

export default TikTokIcon;
